import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

const NavigationProgress = () => {
  const location = useLocation();
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);
  const prevPathRef = useRef(location.pathname);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const clearTimers = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  useEffect(() => {
    if (location.pathname === prevPathRef.current) return;
    prevPathRef.current = location.pathname;

    clearTimers();
    setProgress(0);
    setVisible(true);

    let current = 0;
    intervalRef.current = setInterval(() => {
      current += Math.random() * 18 + 8;
      if (current >= 85) {
        current = 85;
        if (intervalRef.current) clearInterval(intervalRef.current);
      }
      setProgress(current);
    }, 60);

    timerRef.current = setTimeout(() => {
      clearTimers();
      setProgress(100);
      setTimeout(() => {
        setVisible(false);
        setProgress(0);
      }, 300);
    }, 400);

    return clearTimers;
  }, [location.pathname]);

  if (!visible) return null;

  return (
    <div
      className="fixed top-0 left-0 z-[9999] h-[3px] pointer-events-none"
      style={{
        width: `${progress}%`,
        background: 'linear-gradient(90deg, #1E3A8A, #3B82F6)',
        transition: progress === 100
          ? 'width 200ms ease-out, opacity 300ms ease-out'
          : 'width 60ms linear',
        opacity: progress === 100 ? 0 : 1,
        boxShadow: '0 0 8px rgba(59,130,246,0.6)',
      }}
    />
  );
};

export default NavigationProgress;
